import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column justify-center align-center",
  style: {"min-height":"50vh"}
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "container my-4" }
const _hoisted_4 = { class: "row justify-content-center" }
const _hoisted_5 = { class: "col-12 col-md-10 col-lg-8" }
const _hoisted_6 = { class: "card mb-4" }
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "card card-payment" }
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_11 = { class: "fw-bold mb-0" }
const _hoisted_12 = { class: "text-secondary small mb-0" }
const _hoisted_13 = { class: "card mb-4" }
const _hoisted_14 = { class: "card-body" }
const _hoisted_15 = { class: "billing-details mb-4" }
const _hoisted_16 = { class: "text-secondary" }
const _hoisted_17 = { class: "text-end" }
const _hoisted_18 = { class: "fw-bold" }
const _hoisted_19 = { class: "fw-bold" }
const _hoisted_20 = { class: "mt-3" }
const _hoisted_21 = { class: "text-secondary" }
const _hoisted_22 = { class: "text-end" }
const _hoisted_23 = { class: "fw-bold" }
const _hoisted_24 = { class: "fw-bold" }
const _hoisted_25 = { class: "text-end" }
const _hoisted_26 = { class: "text-secondary" }
const _hoisted_27 = { class: "d-flex justify-content-between align-items-center mb-4" }
const _hoisted_28 = { class: "h5 fw-bold mb-0" }
const _hoisted_29 = { class: "next-payment-alert rounded p-3" }
const _hoisted_30 = { class: "mt-3 text-end" }
const _hoisted_31 = { class: "card bg-light border mb-4" }
const _hoisted_32 = { class: "card-body" }
const _hoisted_33 = { class: "text-secondary mb-0 ps-3" }
const _hoisted_34 = { class: "mb-2" }
const _hoisted_35 = { class: "mb-2" }
const _hoisted_36 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_37 = {
  class: "modal fade",
  id: "upgradeDetailsModal",
  tabindex: "-1",
  "aria-labelledby": "upgradeDetailsModalLabel",
  "aria-hidden": "true"
}
const _hoisted_38 = { class: "modal-dialog" }
const _hoisted_39 = { class: "modal-content" }
const _hoisted_40 = ["innerHTML"]

import { ref, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import Subscription, { StripeInvoice, StripeUpcomingInvoice } from '../../../../../api/v2/models/subscription'
import { subscriptionState } from '../../../../stores/subscription'
import PremiumService, { SubscriptionCompare } from '../../../../../api/v2/models/pre_service'
import StripeToken from '../../../../../api/v2/models/stripe_token'
import { format } from 'date-fns'
import StripeElementCardPayComponent from '../../../atoms_molecules/StripeElementCardPay.vue'
import { userState } from '../../../../stores/user'
import api from '../../../../../api/v2/api'
import { calcTaxIncluded } from '../../../../utils/price'
import { loadStripe, Stripe } from '@stripe/stripe-js'
import { getQueryString } from '../../../../../../helpers/route-helper'

// Router

export default /*@__PURE__*/_defineComponent({
  __name: 'PaymentConfirm',
  setup(__props) {

const route = useRoute()
const router = useRouter()

// Reactive state
const subscription = ref<Subscription | null>(null)
const targetPremiumService = ref<PremiumService | null>(null)
const subscriptionCompared = ref<SubscriptionCompare | null>(null)
const stripeUpcomingInvoice = ref<StripeUpcomingInvoice | null>(null)
const stripeLastInvoice = ref<StripeInvoice | null>(null)
const stripeToken = ref<StripeToken | null>(null)
const stripeTokenId = ref<string | null>(null)
const isLoading = ref(true)
const stripePromise = ref<Promise<Stripe | null> | null>(null)
const stripe = ref<Stripe | null>(null)
const paymentIntentClientSecret = ref<string | null>(null)
const paymentMethodCartSetup = ref<any>(null)
const subscriptionIdCartSetup = ref<string | null>(null)
const cardBrand = ref<string>('')
const cardLast4 = ref<string>('')
const cardExpMonth = ref<number | null>(null)
const cardExpYear = ref<number | null>(null)
const subscriptionChangePlanId = ref<string | null>(null)

// Computed properties
const user = computed(() => {
  return userState.user
})

const targetPremiumServiceIdQuery = computed((): string | null => {
  return getQueryString(route.query, 'targetPremiumServiceId')
})

// Methods
const initStripePromise = async () => {
  const stripeKey = typeof window !== 'undefined' && 'stripe_publishable_key' in window 
    ? (window as any).stripe_publishable_key
    : 'pk_test_51JTdp5BLyLEisqmg7jI53Eu2dMWbssUIo4Bcs69zI5ZybYLbAVJCwT5IuIYC6I9qzsIAFtyhnH1ReufLLPoBJMbM001cxeSv9D'

  try {
    stripePromise.value = loadStripe(stripeKey)
    stripe.value = await stripePromise.value
    console.log('Stripe initialized successfully')
  } catch (error) {
    console.error('Failed to initialize Stripe:', error)
  }
}

const getSubscription = () => {
  subscriptionState.getSubscription(route.params.subscriptionId as any).then((response) => {
    if (response) {
      subscription.value = response.subscription
      if (subscription.value.isStoped) {
        window.location.href = '/classroom/subscription/' + subscription.value.id
      }

      stripeUpcomingInvoice.value = response.stripeUpcomingInvoice || new StripeUpcomingInvoice({})
      stripeLastInvoice.value = response.stripeInvoices[0]
    }
  })
}

const getTargetPremiumService = () => {
  subscriptionState
    .getTargetPremiumService(
      route.params.subscriptionId as any,
      targetPremiumServiceIdQuery.value as any
    )
    .then((response) => {
      if (response) {
        targetPremiumService.value = response
        subscriptionCompared.value = response.subscriptionCompare
        isLoading.value = false
      }
    })
}

const openPaymentMethodCartSetup = (paymentMethod: any) => {
  paymentMethodCartSetup.value = paymentMethod
}

const openClientSecretCartSetup = (clientSecret: string) => {
  paymentIntentClientSecret.value = clientSecret
}

const openSubscriptionIdCartSetup = (subscriptionId: string) => {
  subscriptionIdCartSetup.value = subscriptionId
}

const updateCardDetails = (cardDetails: any) => {
  cardBrand.value = cardDetails.brand
  cardLast4.value = cardDetails.last4
  cardExpMonth.value = cardDetails.exp_month
  cardExpYear.value = cardDetails.exp_year
  isLoading.value = true

  window.location.reload() // reload card
}

const submitPaymentConfirm = async () => {
  isLoading.value = true

  try {
    // Ensure Stripe is initialized
    if (!stripe.value) {
      // Try to initialize Stripe again if it failed before
      stripe.value = await stripePromise.value
      if (!stripe.value) {
        throw new Error("Stripe couldn't be initialized. Please refresh and try again.")
      }
    }

    try {
      const response = await api.subscription.create(
        targetPremiumService.value!.id,
        paymentMethodCartSetup.value,
        parseInt(subscriptionIdCartSetup.value || route.params.subscriptionId as string)
      )

      console.log('Payment response:', response)

      if (response.data.paymentStatus !== "requires_confirmation" && response.data.paymentStatus !== "requires_action") {
        isLoading.value = false
        router.push(
          `/classroom/subscription/${route.params.subscriptionId}/change-plan/completion?targetPremiumServiceId=${targetPremiumService.value?.id}`
        )
        return
      }

      // Payment confirmation
      if (response.data.clientSecret) {
        console.log('Payment requires confirmation...', response.data.clientSecret, response.data.paymentMethodId)

        let confirmationResult

        if (response.data.intent_type === 'setup') {
          confirmationResult = await stripe.value.confirmCardSetup(
            response.data.clientSecret,
            {
              payment_method: response.data.paymentMethodId
            }
          )
        } else {
          confirmationResult = await stripe.value.confirmCardPayment(
            response.data.clientSecret,
            {
              payment_method: response.data.paymentMethodId
            }
          )
        }

        const { error } = confirmationResult

        if (error) {
          console.error("Stripe confirmation error:", error)
          throw new Error(error.message || "Payment confirmation failed")
        }

        subscriptionChangePlanId.value = response.data.subscriptionStripe
        checkSubscriptionStatus()

        console.log('Payment confirmed successfully!')
        isLoading.value = false
        router.push(
          `/classroom/subscription/${route.params.subscriptionId}/change-plan/completion?targetPremiumServiceId=${targetPremiumService.value?.id}`
        )
      } else {
        isLoading.value = false
        throw new Error("Payment requires confirmation but no client secret was provided")
      }
    } catch (apiError) {
      isLoading.value = false
      console.error("API Error:", apiError)
      throw apiError
    }
  } catch (error) {
    isLoading.value = false
    console.error("Payment Error:", error)
    alert(error instanceof Error ? error.message : "Payment processing failed. Please try again.")
  }
}

const dateFormat = (date: Date) => {
  return format(date, 'YYYY/MM/DD')
}

const shortDateFormat = (date: Date) => {
  return format(date, 'MM/DD')
}

const localNumber = (number: number) => {
  return new Intl.NumberFormat("ja-JP").format(number)
}

const cardNumber = () => {
  if (cardLast4.value) {
    return `**** **** **** ${cardLast4.value}`
  } else if (stripeToken.value) {
    return `**** **** **** ${stripeToken.value.last4}`
  }
  return `**** **** **** ${subscription.value && subscription.value.stripeCustomerDefaultCardNumber}`
}

const cardDate = () => {
  if (cardExpMonth.value && cardExpYear.value) {
    const month = String(cardExpMonth.value).padStart(2, '0')
    const year = String(cardExpYear.value)
    return `${month}/${year}`
  } else if (stripeToken.value) {
    return `${stripeToken.value.expMonth}/${stripeToken.value.expYear}`
  }
  return subscription.value && subscription.value.stripeCustomerDefaultCardExpiredAt
}

const checkSubscriptionStatus = () => {
  console.log('Checking subscription status...')

  subscriptionState.checkSubscriptionStatus(
    route.params.subscriptionId as any,
    subscriptionChangePlanId.value
  ).then((response) => {
    console.log('Subscription status:', response)
  })
}

// Lifecycle
onMounted(async () => {
  await initStripePromise()
  getSubscription()
  getTargetPremiumService()
})

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_router_link = _resolveComponent("router-link")!

  return (isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_progress_circular, {
          indeterminate: "",
          color: "green",
          size: "48"
        }),
        _cache[0] || (_cache[0] = _createElementVNode("p", { class: "mt-4" }, "データを読み込んでいます。しばらくお待ちください...", -1 /* CACHED */))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _cache[19] || (_cache[19] = _createStaticVNode("<div class=\"progress rounded-0\" data-v-36ae6231><div class=\"progress-bar bg-primary\" style=\"width:66%;\" data-v-36ae6231></div></div><div class=\"container mt-4\" data-v-36ae6231><div class=\"row justify-content-center\" data-v-36ae6231><div class=\"col-12 col-md-10 col-lg-8\" data-v-36ae6231><div class=\"d-flex justify-content-between\" data-v-36ae6231><div class=\"progress-step text-center\" data-v-36ae6231><div class=\"step-circle step-circle-complete mx-auto\" data-v-36ae6231></div><small class=\"d-block mt-2 text-primary\" data-v-36ae6231>プランの確認</small></div><div class=\"progress-step text-center\" data-v-36ae6231><div class=\"step-circle step-circle-active mx-auto\" data-v-36ae6231>2</div><small class=\"d-block mt-2 progress-step-active\" data-v-36ae6231>お支払い</small></div><div class=\"progress-step text-center\" data-v-36ae6231><div class=\"step-circle mx-auto\" data-v-36ae6231>3</div><small class=\"d-block mt-2 text-secondary\" data-v-36ae6231>完了</small></div></div></div></div></div>", 2)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "h6 fw-bold mb-4" }, "お支払い方法", -1 /* CACHED */)),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", null, [
                          _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-secondary mb-2" }, "クレジットカード", -1 /* CACHED */)),
                          _createElementVNode("p", _hoisted_11, _toDisplayString(cardNumber()), 1 /* TEXT */),
                          _createElementVNode("p", _hoisted_12, "有効期限: " + _toDisplayString(cardDate()), 1 /* TEXT */)
                        ]),
                        _withDirectives(_createVNode(StripeElementCardPayComponent, {
                          title: user.value && user.value.currentSchoolName,
                          description: 'カードを変更する',
                          mail: user.value && user.value.email,
                          user_id: String(user.value.id),
                          premiumServiceId: String(targetPremiumService.value.id),
                          changeFromSubscriptionId: String(subscription.value.id),
                          type_change: 'not_default',
                          onPaymentMethodCartSetup: openPaymentMethodCartSetup,
                          onClientSecretCartSetup: openClientSecretCartSetup,
                          onSubscriptionIdCartSetup: openSubscriptionIdCartSetup,
                          onCardDetails: updateCardDetails,
                          class: "change-card-payment"
                        }, null, 8 /* PROPS */, ["title", "mail", "user_id", "premiumServiceId", "changeFromSubscriptionId"]), [
                          [_vShow, user.value]
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _cache[14] || (_cache[14] = _createElementVNode("h2", { class: "h6 fw-bold mb-4" }, "お支払い内容", -1 /* CACHED */)),
                  _createElementVNode("dl", _hoisted_15, [
                    _createElementVNode("dt", null, [
                      _cache[3] || (_cache[3] = _createTextVNode(" 現在のプラン", -1 /* CACHED */)),
                      _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                      _createElementVNode("small", _hoisted_16, "契約更新日: " + _toDisplayString(dateFormat(new Date(stripeUpcomingInvoice.value.periodStart))), 1 /* TEXT */)
                    ]),
                    _createElementVNode("dd", _hoisted_17, [
                      _createTextVNode(_toDisplayString(subscription.value.premiumServiceName), 1 /* TEXT */),
                      _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                      _createElementVNode("span", _hoisted_18, "月額: ¥" + _toDisplayString(localNumber(_unref(calcTaxIncluded)(subscription.value && subscription.value.premiumServicePrice ? subscription.value.premiumServicePrice : 0))), 1 /* TEXT */),
                      _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                      _createElementVNode("span", _hoisted_19, "入会金: ¥" + _toDisplayString(localNumber((subscription.value && subscription.value.needMembershipFee ? subscription.value.membershipFee : 0))) + " (税込み)", 1 /* TEXT */)
                    ]),
                    _createElementVNode("dt", _hoisted_20, [
                      _cache[7] || (_cache[7] = _createTextVNode(" 変更後のプラン", -1 /* CACHED */)),
                      _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                      _createElementVNode("small", _hoisted_21, "次回更新日: " + _toDisplayString(dateFormat(subscriptionCompared.value.targetPaymentAt)), 1 /* TEXT */)
                    ]),
                    _createElementVNode("dd", _hoisted_22, [
                      _createTextVNode(_toDisplayString(targetPremiumService.value.name), 1 /* TEXT */),
                      _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                      _withDirectives(_createElementVNode("br", null, null, 512 /* NEED_PATCH */), [
                        [_vShow, targetPremiumService.value.trialFlag]
                      ]),
                      _createElementVNode("span", _hoisted_23, "月額: ¥" + _toDisplayString(localNumber(targetPremiumService.value.price)), 1 /* TEXT */),
                      _createElementVNode("p", _hoisted_24, "入会金: ¥" + _toDisplayString(localNumber((targetPremiumService.value.membershipFee))) + " (税込み)", 1 /* TEXT */)
                    ]),
                    _cache[10] || (_cache[10] = _createElementVNode("dt", { class: "mt-3" }, "当月日割り差額", -1 /* CACHED */)),
                    _createElementVNode("dd", _hoisted_25, [
                      _createTextVNode(" ¥" + _toDisplayString(localNumber(_unref(calcTaxIncluded)(subscriptionCompared.value.targetPaymentTrialPrice))) + " ", 1 /* TEXT */),
                      _createElementVNode("small", _hoisted_26, "(当月残り" + _toDisplayString(subscriptionCompared.value.targetRemainingDays) + "日分)", 1 /* TEXT */)
                    ])
                  ]),
                  _cache[15] || (_cache[15] = _createElementVNode("hr", { class: "my-4" }, null, -1 /* CACHED */)),
                  _createElementVNode("div", _hoisted_27, [
                    _cache[11] || (_cache[11] = _createElementVNode("h3", { class: "h6 fw-bold mb-0" }, "次回のお支払い額", -1 /* CACHED */)),
                    _createElementVNode("p", _hoisted_28, "¥" + _toDisplayString(localNumber(targetPremiumService.value.price)), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _cache[12] || (_cache[12] = _createElementVNode("i", { class: "bi bi-calendar me-2" }, null, -1 /* CACHED */)),
                    _createTextVNode(" 次回請求日: " + _toDisplayString(dateFormat(subscriptionCompared.value.currentNextPaymentAt)), 1 /* TEXT */)
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_30, [...(_cache[13] || (_cache[13] = [
                    _createElementVNode("a", {
                      href: "#",
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#upgradeDetailsModal",
                      class: "text-primary text-decoration-none"
                    }, "詳しく", -1 /* CACHED */)
                  ]))], 512 /* NEED_PATCH */), [
                    [_vShow, subscriptionCompared.value.descriptionHtml]
                  ])
                ])
              ]),
              _createCommentVNode(" Terms "),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("ul", _hoisted_33, [
                    _createElementVNode("li", _hoisted_34, "アップグレードは" + _toDisplayString(shortDateFormat(new Date())) + "に適用されます。", 1 /* TEXT */),
                    _createElementVNode("li", _hoisted_35, " 当月残り" + _toDisplayString(subscriptionCompared.value.targetRemainingDays) + "日分の日割り差額 ¥" + _toDisplayString(localNumber(_unref(calcTaxIncluded)(subscriptionCompared.value.targetPaymentTrialPrice))) + " が即時請求されます。 ", 1 /* TEXT */),
                    _createElementVNode("li", null, _toDisplayString(shortDateFormat(subscriptionCompared.value.targetPaymentAt)) + "以降は新プラン月額 ¥" + _toDisplayString(localNumber(targetPremiumService.value.price)) + " が適用されます。 ", 1 /* TEXT */)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createVNode(_component_router_link, {
                  to: 
                `/classroom/subscription/${subscription.value.id}/change-plan/plan-confirm?targetPremiumServiceId=${targetPremiumService.value.id}`
              ,
                  class: "btn btn-light border px-4"
                }, {
                  default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                    _createTextVNode("前に戻る", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["to"]),
                _createElementVNode("div", { class: "text-end" }, [
                  _createElementVNode("button", {
                    onClick: submitPaymentConfirm,
                    class: "btn btn-primary px-4 text-white"
                  }, "変更を確定する"),
                  _cache[17] || (_cache[17] = _createElementVNode("div", { class: "secure-payment mt-2" }, [
                    _createElementVNode("i", { class: "bi bi-lock-fill me-1" }),
                    _createTextVNode(" セキュアな支払い処理 ")
                  ], -1 /* CACHED */))
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _cache[18] || (_cache[18] = _createElementVNode("div", { class: "modal-header" }, [
                _createElementVNode("h5", {
                  class: "modal-title",
                  id: "upgradeDetailsModalLabel"
                }, "アップグレード料金の計算内訳"),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  "data-bs-dismiss": "modal",
                  "aria-label": "閉じる"
                })
              ], -1 /* CACHED */)),
              _createElementVNode("div", {
                class: "modal-body",
                innerHTML: subscriptionCompared.value.descriptionHtml
              }, null, 8 /* PROPS */, _hoisted_40)
            ])
          ])
        ])
      ]))
}
}

})